import { useAuth0 } from '@auth0/auth0-react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { logoutService } from '../../services/logoutService';
import { resetAnalyticsUser } from '../../services/analyticsService';

export function LogoutHandler() {
  const { logout } = useAuth0();
  const queryClient = useQueryClient();

  useEffect(() => {
    // Clear app state
    logoutService.clearAppState(queryClient);
    resetAnalyticsUser();

    // Call Auth0 logout
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout, queryClient]);

  return null;
}

export default LogoutHandler;
